<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import AppShell from '@/components/AppShell.vue'
import { useSessionStore } from '@/stores/session'

const session = useSessionStore()
const route = useRoute()
const router = useRouter()

watch(
  () => [session.ready, session.authenticated, session.me, route.fullPath] as const,
  () => {
    if (!session.ready || !session.authenticated || !session.me) return
    const scopes = Array.isArray(route.meta.scopes) ? (route.meta.scopes as string[]) : []
    if (scopes.length > 0 && !session.canAny(scopes)) void router.replace('/')
  },
  { deep: false },
)

onMounted(() => session.bootstrap())
</script>

<template>
  <a class="skip-link" href="#main-content">Saltar al contenido</a>
  <main v-if="!session.ready || session.loading" class="center-stage" aria-busy="true">
    <div class="loading-orbit" aria-hidden="true"></div>
    <p>Conectando con BlazeDSP…</p>
  </main>

  <main v-else-if="session.error" class="center-stage">
    <section class="auth-card">
      <span class="brand-mark">B</span>
      <p class="eyebrow">BlazeDSP</p>
      <h1>No pudimos abrir la consola</h1>
      <p>{{ session.error }}</p>
      <button class="button primary" type="button" @click="session.bootstrap()">Reintentar</button>
    </section>
  </main>

  <main v-else-if="!session.authenticated" class="center-stage auth-stage">
    <section class="auth-card">
      <span class="brand-mark">B</span>
      <p class="eyebrow">Blaze Delivery &amp; Service Platform</p>
      <h1>Seguimiento operacional sin puntos ciegos.</h1>
      <p>Accede con Blaze Identity. La sesión, el tenant y los tokens permanecen protegidos por el BFF.</p>
      <button class="button primary wide" type="button" @click="session.login($route.fullPath)">
        Continuar con Blaze Identity
      </button>
    </section>
  </main>

  <AppShell v-else />
</template>
